function handleLine(box, textEle, moreEle) {
  if(textEle && moreEle){
    if(textEle.scrollHeight > textEle.offsetHeight){
        moreEle.classList.add('show');
    }
    moreEle.addEventListener('click', e => {
        e.stopPropagation();
        moreEle.classList.remove('show');
        if( box.classList.contains('ellipsis2') ){
          box.classList.remove('ellipsis2');
          return false;
        }
        if( box.classList.contains('ellipsis3') ){
          box.classList.remove('ellipsis3');
          return false;
        }
    });
  }
}

function ellipsis ({element}) {
  const boxs = document.querySelectorAll(element);
  if(boxs){
    boxs.forEach((box, index) => {
      const textEle = box.querySelector('.text');
      const moreEle = box.querySelector('.more');
      handleLine(box, textEle, moreEle);
    });
  }
}

export default ellipsis;
